import { ChangeEvent } from "react";

import SimpleErrorMessage from "../error-message/new-error-message";
import { cn } from "@/utils/utils";
import { Label } from "./label";

type InputProps = {
    id: string;
    labelText: string;
    isError?: boolean;
    errorMsg?: string;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    value?: Date;
    ariaLabel?: string
    isFilled?: boolean;
    required?: boolean;
    disabled?: boolean;
};

export default function DesktopDatepicker({ ...props }: InputProps) {
    return (
        <div className="w-full container-input group flex flex-col">
            <Label
                disabled={props.disabled}
                required={props.required}
                htmlFor={props.id}>
                {props.labelText}
            </Label>
            <input
                id={props.id}
                disabled={props.disabled}
                value={props.value ? props.value.toISOString().split('T')[0] : ''}
                className={cn(
                    "focus:outline-none rounded-lg",
                    "disabled:bg-[var(--surface-disabled)] disabled:text-[var(--on-surface-variant-2)] disabled:border-[var(--outline-disabled)]",
                    "h-24 pl-5 pr-12 w-full text-base",
                    "bg-[var(--surface-default)] border-[1px]",
                    "border-[var(--outline-default)]",
                    "text-[var(--on-surface-default)]",
                )}
                title={props.labelText}
                type="date"
                min={"1900-01-01"}
                max={"2026-01-01"}
                aria-label={props.ariaLabel}
                onChange={props.onChange}
                inputMode="numeric"
                style={{
                    WebkitAppearance: 'unset'
                }}
            />
            <SimpleErrorMessage id={props.id + "__error-message"} error={props.errorMsg} />
        </div>
    );
}
